var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBedMgmtAc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H30C35.5228 0 40 4.47715 40 10V30C40 35.5228 35.5228 40 30 40H10C4.47715 40 0 35.5228 0 30V10Z",
    fill: "#FFEDD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6665 26.3335C20.8778 26.4919 21.1237 26.5979 21.3839 26.6427C21.6442 26.6875 21.9114 26.6698 22.1634 26.591C22.4155 26.5123 22.6453 26.3748 22.8338 26.1898C23.0223 26.0048 23.1641 25.7777 23.2476 25.5272C23.3312 25.2767 23.3539 25.0099 23.3141 24.7488C23.2743 24.4877 23.173 24.2399 23.0186 24.0256C22.8642 23.8114 22.661 23.6369 22.426 23.5166C22.1909 23.3963 21.9306 23.3335 21.6665 23.3335H11.6665",
    stroke: "#F54900",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5832 16.6668C24.7962 16.3827 25.0784 16.1578 25.4028 16.0134C25.7273 15.8691 26.0832 15.81 26.4369 15.8419C26.7906 15.8738 27.1303 15.9956 27.4237 16.1957C27.717 16.3957 27.9544 16.6675 28.1132 16.9851C28.272 17.3028 28.347 17.6557 28.3311 18.0105C28.3151 18.3652 28.2087 18.71 28.022 19.0121C27.8353 19.3142 27.5745 19.5635 27.2643 19.7365C26.9542 19.9094 26.605 20.0002 26.2498 20.0002H11.6665",
    stroke: "#F54900",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1665 13.6668C18.3778 13.5084 18.6237 13.4024 18.8839 13.3576C19.1442 13.3129 19.4114 13.3306 19.6634 13.4093C19.9155 13.488 20.1453 13.6256 20.3338 13.8105C20.5223 13.9955 20.6641 14.2226 20.7476 14.4731C20.8312 14.7237 20.8539 14.9904 20.8141 15.2515C20.7743 15.5126 20.673 15.7604 20.5186 15.9747C20.3642 16.1889 20.161 16.3634 19.926 16.4837C19.6909 16.6041 19.4306 16.6668 19.1665 16.6668H11.6665",
    stroke: "#F54900",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedMgmtAc);
export default __webpack_public_path__ + "static/media/bedMgmtAC.57b7c93162bd2c300fd7729f2d58ba6e.svg";
export { ForwardRef as ReactComponent };